var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cta-container",
      class: { [_vm.size]: true },
      style: `--size: ${_vm.size};--type: ${_vm.type}`,
    },
    [
      _c(
        _vm.href ? "a" : "button",
        {
          tag: "component",
          staticClass: "CTA",
          class: _vm.buttonClass,
          attrs: {
            "data-start-on-path": _vm.startOnPath,
            href: _vm.href,
            rel: _vm.rel,
            target: _vm.target,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("clickedCTA")
            },
          },
        },
        [_c("span", { staticClass: "CTA__button" }, [_vm._t("default")], 2)]
      ),
      _vm._v(" "),
      _vm.description
        ? _c(
            "p",
            { staticClass: "description" },
            [_c("mixed-color-label", { attrs: { text: _vm.description } })],
            1
          )
        : _vm.$slots.description
        ? _c("p", { staticClass: "description" }, [_vm._t("description")], 2)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }